module.exports = __webpack_public_path__ + "img/upload-failed.251f5297.svg";